import { render, staticRenderFns } from "./additionalInfoForm.vue?vue&type=template&id=79e24427"
import script from "./additionalInfoForm.vue?vue&type=script&lang=js"
export * from "./additionalInfoForm.vue?vue&type=script&lang=js"
import style0 from "./additionalInfoForm.vue?vue&type=style&index=0&id=79e24427&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports